import { useQuery } from '@tanstack/react-query';

import { getAttraction } from '~/services/AttractionsService';

import { getCacheBuster } from './attractionCacheBuster';
import { attractionQueryKeys } from './attractionQueryKeys';

/**
 * Fetches a single attraction by ID via GET /attractions/:attractionId.
 *
 * If the current session has a pending post-mutation cache-buster for this
 * attraction, it is appended as ?v={updatedAt} so CloudFront serves a fresh
 * body instead of the pre-mutation cached entry. See attractionCacheBuster.ts.
 */
export function useGetAttraction(attractionId: string) {
  return useQuery({
    queryKey: attractionQueryKeys.detail(attractionId),
    queryFn: async ({ signal }) => {
      const v = getCacheBuster(attractionId);
      const response = await getAttraction(attractionId, { signal, v });
      return response.result ?? null;
    },
    enabled: !!attractionId,
    retry: false,
  });
}
